var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconAurea = function SvgIconAurea(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28.182,
    height: 38.763,
    viewBox: "0 0 28.182 38.763",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-19.557 -30.592)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1098.016,228.229a14.091,14.091,0,1,0,0,22v3.091h5.284V225.137h-5.284Zm-8.74,19.806a8.807,8.807,0,1,1,8.74-8.873A8.807,8.807,0,0,1,1089.275,248.035Z",
    transform: "translate(-1055.561 -183.965)",
    fill: "#f6c866"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1129.4,178.507a5.284,5.284,0,0,0,1.58-7.3,8.807,8.807,0,0,1-8.926,5.657l.042.066A5.284,5.284,0,0,0,1129.4,178.507Z",
    transform: "translate(-1093.287 -140.612)",
    fill: "#f6c866"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconAurea, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-aurea.e34f28eb.svg";
export { ForwardRef as ReactComponent };